import {
  FETCH_BATCH_PROCESSES_REQUEST,
  FETCH_BATCH_PROCESSES_SUCCESS,
  FETCH_BATCH_PROCESSES_FAILURE,
  DELETE_BATCH_PROCESS_REQUEST,
  DELETE_BATCH_PROCESS_SUCCESS,
  DELETE_BATCH_PROCESS_FAILURE,
} from '../../types/batchInventoryProcess/batchInventoryProcessTypes';

const initialState = {
  processes: [],
  loading: false,
  error: null,
  appending: false,
};

const batchInventoryProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BATCH_PROCESSES_REQUEST:
      return {
        ...state,
        loading: action.append ? state.loading : true,
        appending: Boolean(action.append),
        error: null,
      };
    case DELETE_BATCH_PROCESS_REQUEST:
      return {
        ...state,
        loading: true,
        appending: false,
      };
    case FETCH_BATCH_PROCESSES_SUCCESS:
      if (action.append) {
        const existingIds = new Set(state.processes.map(item => item.id));
        const appended = [
          ...state.processes,
          ...action.payload.filter(item => !existingIds.has(item.id)),
        ];
        return {
          ...state,
          loading: false,
          appending: false,
          processes: appended,
        };
      }
      return {
        ...state,
        loading: false,
        appending: false,
        processes: action.payload,
      };
    case DELETE_BATCH_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        appending: false,
        processes: state.processes.filter(p => p.id !== action.payload),
      };
    case FETCH_BATCH_PROCESSES_FAILURE:
      return {
        ...state,
        loading: false,
        appending: false,
        error: action.payload,
      };
    case DELETE_BATCH_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        appending: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default batchInventoryProcessReducer; 